import React from 'react';
import { Container } from './styles';
import { Word } from 'react-wordcloud';

interface TooltipProps {
  word: Word | null;
  x: number;
  y: number;
  visible: boolean;
}

const Tooltip: React.FC<TooltipProps> = ({ word, x, y, visible }) => {
  if (!word) return null;

  return (
    <Container
      style={{
        left: x + 10,
        top: y + 10,
        opacity: visible ? 1 : 0,
      }}
    >
      <div style={{ fontWeight: 'bold' }}>{word.text}</div>
      <div style={{ color: '#777' }}>
        <span style={{ color: '#A54DD7' }}>●</span>
        {` Total: `}
        <strong>{word.value}</strong>
      </div>
    </Container>
  );
};

export default Tooltip;